module.exports = __webpack_public_path__ + "media/svg/ar-40a9330d.svg";